// -----------  Match Height JS  ---------

window.onload = function() {
  matchHeight('.cart-drawer-content .abz-cart-recommendations .card .card__information');
  matchHeight('.abz-main-cart-recommendations .abz-cart-recommendations .card .card__information');
};

function matchHeight(selector) {
  // Select all elements with the specified selector
  var elements = document.querySelectorAll(selector);
  var maxHeight = 0;

  // First, find the tallest element
  elements.forEach(function(element) {
    if (element.offsetHeight > maxHeight) {
      maxHeight = element.offsetHeight;
    }
  });

  // Then, set all elements to the maxHeight
  elements.forEach(function(element) {
    element.style.height = maxHeight + 'px';
  });
}

//-------------------------------------------------




customElements.define(
  "abz-cart-recommendations",
  class extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector(".abz-cart-recommendations__wrapper");
      this.sliderComponent = this.querySelector("sliders-component") || null;
    }
    async connectedCallback() {
      // this.slider.innerHTML = '<div class="abz-cart-recommendations__loading">Loading recommendations...</div>';
      // Wait for any slotted or child content to be available
      const spans = Array.from(
        this.querySelectorAll("span[data-recommendations-url]")
      );
      if (!spans.length || !this.slider) {
        console.log(
          "No recommendation spans found or wrapper missing, removing element"
        );
        this.remove();
        return;
      }
      try {
        const htmls = await Promise.all(
          spans.map(async (span) => {
            const url = span.getAttribute("data-recommendations-url");
            if (!url) return "";
            const res = await fetch(url);
            if (!res.ok) return "";
            const text = await res.text();
            // Try to extract the section HTML if present
            // Shopify returns a JSON with 'sections' if section_id is used
            try {
              const json = JSON.parse(text);
              if (json.sections && json.sections["abz-cart-recommendations"]) {
                return json.sections["abz-cart-recommendations"];
              }
            } catch (e) {
              // Not JSON, fallback to raw HTML
              return text;
            }
            return "";
          })
        );
        // Remove loading
        this.slider.innerHTML = "";
        // Append all fetched HTML
        let appendedCount = 0;
        htmls.forEach((html) => {
          if (html && html.trim() && appendedCount < 8) {
            const wrapper = document.createElement("div");
            wrapper.innerHTML = html;
            const recommendedItems = wrapper.querySelectorAll(
              ".abz-cart-recommendations__item > *"
            );
            recommendedItems.forEach((item) => {
              if (appendedCount < 8) {
                this.slider.append(item);
                appendedCount++;
              }
            });
          }
        });
        
        if (!htmls.some((html) => html && html.trim())) {
          console.log("No valid HTML content found, removing element");
          this.remove();
        } else {
          // pluck all the <quick-add-modal> elements & move them to the bottom of body tag
          const quickAddModals = document.querySelectorAll('quick-add-modal');
          quickAddModals.forEach(modal => {
            if (modal.parentNode !== document.body) {
              document.body.appendChild(modal);
            }
          });

          if (this.dataset.type === 'section') {
            $(this.slider).slick({
              arrows: false,
              dots: true,
              appendDots: this.querySelector('.slider-counter--dots'),
              infinite: true,
              speed: 300,
              slidesToShow: 4,
              slidesToScroll: 2,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    appendDots: this.querySelector('.slider-counter--dots'),
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                  }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
              ]
            });
          } else {
            $(this.slider).slick({
              arrows: false,
              appendDots: this.querySelector('.slider-counter--dots'),
              dots: true,
              infinite: true,
              speed: 300,
              slidesToShow: 2,
              slidesToScroll: 2
            });
          }

          const prevBtn = this.querySelector('.slider-button--prev');
          const nextBtn = this.querySelector('.slider-button--next');
          const dots = this.querySelector('.slider-counter--dots');

          prevBtn.addEventListener('click', () => {
            $(this.slider).slick('slickPrev');
          });

          nextBtn.addEventListener('click', () => {
            $(this.slider).slick('slickNext');
          });

          matchHeight('.cart-drawer-content .abz-cart-recommendations .card .card__information');
          matchHeight('.abz-main-cart-recommendations .abz-cart-recommendations .card .card__information');

          // Dynamically render slider dots in the cart drawer
          // const sliderDotsContainer = this.sliderComponent.querySelector('.slider-counter--dots .slideshow__control-wrapper');
          // if (sliderDotsContainer) {
          //   sliderDotsContainer.innerHTML = '';
          //   const dots = this.slider.querySelector('.slick-dots');
          //   sliderDotsContainer.appendChild(dots);
          // }

        }
      } catch (e) {
        console.log("Error loading recommendations:", e);
        this.remove();
      }
    }
  }
);

// --- Javatech URL open new tab

  document.addEventListener("DOMContentLoaded", function() {
    const link = document.getElementById("HeaderMenu-our-brands-javatechs");
    if (link) {
      link.addEventListener("click", function(e) {
        e.preventDefault(); 
        window.open(link.href, "_blank");
      });
    }
  });


